import { StackName } from "@/components/shared/stack-iconmapper";

export const AWARD = [
  "서울시 그래픽스 부분 대상 (서울시 교육감상)",
  "전국 그래픽스 부분 은상 (숭실대 IT학장 상)",
];
type StackItem = {
  name: StackName;
  description: string;
};

type StackSection = {
  title: string;
  color: string;
  items: string[];
};

type StackGroup = {
  category: "Front-end" | "Server Stack" | "Infra & Design Tool";
  trigger: string;
  stacks: StackItem[];
  sections: StackSection[];
};

export const STACKS: StackGroup[] = [
  {
    category: "Front-end",
    trigger:
      "최신 프론트엔드 흐름을 반영하며 구조적 설계와 사용자 경험, 렌더링 최적화에 초점을 두고 개발하며 빠른 퍼블리싱과 인터렉티브 UI를 구현하는 것을 즐깁니다.",
    stacks: [
      {
        name: "typescript",
        description: "제네릭과 유틸리티 타입으로 안정성 확보",
      },
      {
        name: "next.js",
        description: "App Router 기반 캐싱 설계 및 트래픽 절약",
      },
      {
        name: "react",
        description: "컴포넌트 기반 설계와 상태 관리 중심 UI 구현",
      },
      { name: "react-query", description: "비동기 상태 관리 및 캐싱 핸들링" },
      { name: "zustand", description: "가벼운 전역 상태 관리" },
      { name: "react-hook-form", description: "폼 상태 관리 및 유효성 최적화" },
      { name: "zod", description: "데이터 스키마 및 폼 유효성 검증" },
      {
        name: "gsap",
        description: "Reflow 최소화 인터랙션 및 스크롤 애니메이션",
      },
      {
        name: "tailwind",
        description: "유틸리티 기반 퍼블리싱 및 디자인 시스템화",
      },
      { name: "scss", description: "모듈 단위 스타일 관리" },
      { name: "vitest", description: "컴포넌트 단위 테스트 및 안정성 보장" },
      { name: "nextauth", description: "빠른 인증인가와 Token 관리" },
    ],
    sections: [
      {
        title: "핵심 역량",
        color: "bg-pink-400",
        items: [
          "상태·비동기 관리 및 캐싱 최적화 (TanStack Query, Zustand)",
          "Next.js Cache 철학 기반 렌더링 및 트래픽 최소화 설계",
          "일관된 UI 시스템 구축(Shadcn, SCSS, Tailwind)",
          "Reflow 최소화 및 GSAP 애니메이션 최적화",
          "React Compiler·Vitest 등 최신 스펙 대응",
        ],
      },
    ],
  },
  {
    category: "Server Stack",
    trigger:
      "프론트엔드 개발자로서 백엔드 아키텍처와 데이터 흐름을 이해하며, 협업 과정의 효율성과 기술적 시야를 넓혀가고 있습니다.",
    stacks: [
      { name: "node.js", description: "API 및 서버 환경 구성" },
      { name: "nest.js", description: "Layered 구조와 Guard, DTO 설계" },
      {
        name: "drizzleorm",
        description: "타입 안전한 ORM 기반 쿼리 및 마이그레이션",
      },
      { name: "postgresql", description: "RDBMS·트랜잭션 기반 데이터 관리" },
      { name: "supabase", description: "BaaS 인증 및 스토리지 관리" },
    ],
    sections: [
      {
        title: "기술 운용",
        color: "bg-pink-400",
        items: [
          "Drizzle ORM으로 타입 안전한 DB 쿼리 및 마이그레이션 관리",
          "Nest.js 기반 계층형 구조와 인증·인가 로직 구현",
          "bcrypt·JWT 인증 시스템 설계",
          "Docker Compose로 테스트 환경 통합",
          "drizzle-kit으로 운영·개발 DB 구조 동기화",
        ],
      },
    ],
  },
  {
    category: "Infra & Design Tool",
    trigger:
      "배포 및 인프라 환경에 대한 시야를 넓히고 안정적인 서비스 구현을 하기 위해 정진하고 있습니다.",
    stacks: [
      { name: "aws", description: "S3·CloudFront 기반 CDN 및 배포 관리" },
      { name: "git", description: "브랜치 전략 및 버전 관리 협업" },
      { name: "vercel", description: "서버리스 배포 및 Git 연동" },
      {
        name: "docker",
        description: "테스트 환경 통일 및 docker-compose CI 환경 구성",
      },
      { name: "figma", description: "UI 프로토타입 설계 " },
      {
        name: "photoshop",
        description: "웹용 에셋 제작 및 그래픽 리소스 관리",
      },
    ],
    sections: [
      {
        title: "인프라 및 자동화",
        color: "bg-pink-400",
        items: [
          "AWS S3 + CloudFront로 CDN 구성",
          "EC2 + Nginx, RDS + MySQL 환경 구축",
          "GitHub Actions로 S3 자동 배포 파이프라인 구현",
          "SVN·Git 기반 버전 관리 경험",
          "Figma·Adobe Tool을 활용한 시안 제작 및 에셋 디자인",
        ],
      },
    ],
  },
];
